import http from "./AxiosInstance";

class BilanClientService {

  getBilanGeneral(params = {}) {
    return http.get(`/bilanClient/bilan-general`, { params });
  }

  // Bilan quotidien
  getBilanQuotidien(date = null) {
    const url = date 
      ? `/bilanClient/bilan-quotidien/${date}`
      : `/bilanClient/bilan-quotidien`;
    return http.get(url);
  }

  // Bilan mensuel
  getBilanMensuel(annee, mois) {
    return http.get(`/bilanClient/bilan-mensuel/${annee}/${mois}`);
  }

  // Impayés détaillés
  getImpayesDetaille(params = {}) {
    return http.get(`/bilanClient/impayes-detaille`, { params });
  }
}

const bilanClientService = new BilanClientService();
export default bilanClientService;